export default __webpack_public_path__ + "d78ef053f59409111b49562f8a289fe1.png";